module.exports = __webpack_public_path__ + "static/media/muffled-laser-blast.4554048b.ogg";